import http, { API_CORE } from '../http';

export default function OrderItemService() {
  const updateStatus = async (id, input) => {
    const response = await http(API_CORE).put(`/orders/items/${id}/status/${input.statusKey}`);
    return response.data;
  };

  return {
    updateStatus: updateStatus,
  };
}
